import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedMethodsService } from 'src/app/services/shared-methods.service';
import { UserStorageService } from 'src/app/services/storage/user-storage.service';
import { Trip } from '../../data-models/trip-models/trip.model';
import { UserData } from '../../data-models/user-models/user-data.model';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'app-submission-page',
    templateUrl: './submission-page.component.html',
    styleUrls: ['./submission-page.component.css'],
    standalone: false
})
export class SubmissionPage {

  // data preambles
  reportName: string = "";
  userDetails: UserData = new UserData();
  currTrip: Trip = new Trip();
  reportSent: boolean = false;
  isEditSubmission = false;


  constructor(
    private router: Router,
    public authenticationService: AuthenticationService,
    public sharedMethodsService: SharedMethodsService
  ) {

    this.initialize();

  }

  initialize(): void {

    // get report name for submission success message
    this.reportName = this.router.getCurrentNavigation()?.extras.state?.name;
    // get the isSubmitted flag (indicates whether or not the report was sent to DFO)
    this.reportSent = this.router.getCurrentNavigation()?.extras.state?.success ?? false;
    // if this is an edit submission, set the flag
    this.isEditSubmission = this.router.getCurrentNavigation()?.extras.state?.isEditSubmission === true;

    this.authenticationService.getUserDetails().then(() => {
      this.userDetails = UserStorageService.currUser;
    });

  }


}
